// Quartz day-of-week is 1=SUN..7=SAT, Unix cron is 0=SUN..6=SAT
const shiftQuartzDayOfWeek = (field: string) =>
  field
    .split(',')
    .map((part) => {
      const [range, step] = part.split('/')
      const [days, nth] = range.split('#')
      const shifted = days.replace(/\d+/g, (day) =>
        String(Math.max(Number(day) - 1, 0))
      )
      const withNth = nth !== undefined ? `${shifted}#${nth}` : shifted

      return step !== undefined ? `${withNth}/${step}` : withNth
    })
    .join(',')

/**
 * Converts a Quartz cron (6 fields with seconds, or 7 with year) to the
 * 5-field Unix format accepted by react-js-cron and the BE (Cronos).
 * 5-field values are returned unchanged except for '?' -> '*'.
 */
export const normalizeCron = (value?: string | null) => {
  if (!value) return value ?? undefined

  const fields = value.trim().split(/\s+/)

  if (fields.length === 5) {
    return fields.map((field) => (field === '?' ? '*' : field)).join(' ')
  }

  if (fields.length !== 6 && fields.length !== 7) return value

  const [, minute, hour, dayOfMonth, month, dayOfWeek] = fields

  return [
    minute,
    hour,
    dayOfMonth === '?' ? '*' : dayOfMonth,
    month,
    dayOfWeek === '?' ? '*' : shiftQuartzDayOfWeek(dayOfWeek)
  ].join(' ')
}
